import React from 'react'

import LogoBar from 'components/logo/LogoBar'

export default function TrustedLogoBar ({ logos }) {
  return <LogoBar redesign title="Trusted by:" logos={logos} />
}
